import React from 'react';

const Hero = () => {
  return (
    <section className="hero" style={{
      backgroundImage: "url('/background.png')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }}>
      <div className="container">
        <h1>Custom ERP Software for Manufacturing</h1>
        <p>Skyline Digital Solutions offers specialized software for manufacturing companies in the Benelux region. Our flagship product WorkflowNL integrates production, inventory, and finance with local compliance features.</p>
        <div className="hero-buttons">
          <a href="#demo" className="btn">Free Demo</a>
          <a href="#contact" className="btn btn-outline">More Information</a>
        </div>
      </div>
    </section>
  );
};

export default Hero;